// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code/code_values#Code_values_on_Windows
export type KeyboardEventCode =
  | ''
  | 'Unidentified'
  | 'Escape'
  | 'Digit0'
  | 'Digit1'
  | 'Digit2'
  | 'Digit3'
  | 'Digit4'
  | 'Digit5'
  | 'Digit6'
  | 'Digit7'
  | 'Digit8'
  | 'Digit9'
  | 'Minus'
  | 'Equal'
  | 'Backspace'
  | 'Tab'
  | 'KeyQ'
  | 'KeyW'
  | 'KeyE'
  | 'KeyR'
  | 'KeyT'
  | 'KeyY'
  | 'KeyU'
  | 'KeyI'
  | 'KeyO'
  | 'KeyP'
  | 'BracketLeft'
  | 'BracketRight'
  | 'Enter'
  | 'ControlLeft'
  | 'KeyA'
  | 'KeyS'
  | 'KeyD'
  | 'KeyS'
  | 'KeyF'
  | 'KeyG'
  | 'KeyH'
  | 'KeyJ'
  | 'KeyK'
  | 'KeyL'
  | 'Semicolon'
  | 'Quote'
  | 'Backquote'
  | 'ShiftLeft'
  | 'Backslash'
  | 'KeyZ'
  | 'KeyX'
  | 'KeyC'
  | 'KeyV'
  | 'KeyB'
  | 'KeyN'
  | 'KeyM'
  | 'Comma'
  | 'Period'
  | 'Slash'
  | 'ShiftRight'
  | 'NumpadMultiply'
  | 'AltLeft'
  | 'Space'
  | 'CapsLock'
  | 'F1'
  | 'F2'
  | 'F3'
  | 'F4'
  | 'F5'
  | 'F6'
  | 'F7'
  | 'F8'
  | 'F9'
  | 'F10'
  | 'Pause'
  | 'ScrollLock'
  | 'Numpad7'
  | 'Numpad8'
  | 'Numpad9'
  | 'NumpadSubtract'
  | 'Numpad4'
  | 'Numpad5'
  | 'Numpad6'
  | 'NumpadAdd'
  | 'Numpad1'
  | 'Numpad2'
  | 'Numpad3'
  | 'Numpad0'
  | 'NumpadDecimal'
  | 'PrintScreen'
  | 'IntlBackslash'
  | 'F11'
  | 'F12'
  | 'NumpadEqual'
  | 'F13'
  | 'F14'
  | 'F15'
  | 'F16'
  | 'F17'
  | 'F18'
  | 'F19'
  | 'F20'
  | 'F21'
  | 'F22'
  | 'F23'
  | 'F24'
  | 'F24'
  | 'KanaMode'
  | 'Convert'
  | 'NonConvert'
  | 'IntlYen'
  | 'NumpadComma'
  | 'MediaTrackPrevious'
  | 'MediaTrackNext'
  | 'NumpadEnter'
  | 'ControlRight'
  | 'AudioVolumeMute'
  | 'LaunchApp2'
  | 'MediaPlayPause'
  | 'MediaStop'
  | 'AudioVolumeDown'
  | 'VolumeDown'
  | 'AudioVolumeUp'
  | 'VolumeUp'
  | 'BrowserHome'
  | 'NumpadDivide'
  | 'AltRight'
  | 'Help'
  | 'NumLock'
  | 'Home'
  | 'ArrowUp'
  | 'PageUp'
  | 'ArrowLeft'
  | 'ArrowRight'
  | 'End'
  | 'ArrowDown'
  | 'PageDown'
  | 'Insert'
  | 'Delete'
  | 'MetaLeft'
  | 'OSLeft'
  | 'MetaRight'
  | 'OSRight'
  | 'ContextMenu'
  | 'BrowserSearch'
  | 'BrowserFavorites'
  | 'BrowserRefresh'
  | 'BrowserStop'
  | 'BrowserForward'
  | 'BrowserBack'
  | 'LaunchApp1'
  | 'LaunchMail'
  | 'LaunchMediaPlayer'
  | 'MediaSelect'
  | 'Lang1'
  | 'Lang2'
  | 'IntlRo'
  | 'Power';

export const codeScancodeMap = new Map<KeyboardEventCode, number>();
codeScancodeMap.set('Escape', 0x0001);
codeScancodeMap.set('Digit1', 0x0002);
codeScancodeMap.set('Digit2', 0x0003);
codeScancodeMap.set('Digit3', 0x0004);
codeScancodeMap.set('Digit4', 0x0005);
codeScancodeMap.set('Digit5', 0x0006);
codeScancodeMap.set('Digit6', 0x0007);
codeScancodeMap.set('Digit7', 0x0008);
codeScancodeMap.set('Digit8', 0x0009);
codeScancodeMap.set('Digit9', 0x000a);
codeScancodeMap.set('Digit0', 0x000b);
codeScancodeMap.set('Minus', 0x000c);
codeScancodeMap.set('Equal', 0x000d);
codeScancodeMap.set('Backspace', 0x000e);
codeScancodeMap.set('Tab', 0x000f);
codeScancodeMap.set('KeyQ', 0x0010);
codeScancodeMap.set('KeyW', 0x0011);
codeScancodeMap.set('KeyE', 0x0012);
codeScancodeMap.set('KeyR', 0x0013);
codeScancodeMap.set('KeyT', 0x0014);
codeScancodeMap.set('KeyY', 0x0015);
codeScancodeMap.set('KeyU', 0x0016);
codeScancodeMap.set('KeyI', 0x0017);
codeScancodeMap.set('KeyO', 0x0018);
codeScancodeMap.set('KeyP', 0x0019);
codeScancodeMap.set('BracketLeft', 0x001a);
codeScancodeMap.set('BracketRight', 0x001b);
codeScancodeMap.set('Enter', 0x001c);
codeScancodeMap.set('ControlLeft', 0x001d);
codeScancodeMap.set('KeyA', 0x001e);
codeScancodeMap.set('KeyS', 0x001f);
codeScancodeMap.set('KeyD', 0x0020);
codeScancodeMap.set('KeyF', 0x0021);
codeScancodeMap.set('KeyG', 0x0022);
codeScancodeMap.set('KeyH', 0x0023);
codeScancodeMap.set('KeyJ', 0x0024);
codeScancodeMap.set('KeyK', 0x0025);
codeScancodeMap.set('KeyL', 0x0026);
codeScancodeMap.set('Semicolon', 0x0027);
codeScancodeMap.set('Quote', 0x0028);
codeScancodeMap.set('Backquote', 0x0029);
codeScancodeMap.set('ShiftLeft', 0x002a);
codeScancodeMap.set('Backslash', 0x002b);
codeScancodeMap.set('KeyZ', 0x002c);
codeScancodeMap.set('KeyX', 0x002d);
codeScancodeMap.set('KeyC', 0x002e);
codeScancodeMap.set('KeyV', 0x002f);
codeScancodeMap.set('KeyB', 0x0030);
codeScancodeMap.set('KeyN', 0x0031);
codeScancodeMap.set('KeyM', 0x0032);
codeScancodeMap.set('Comma', 0x0033);
codeScancodeMap.set('Period', 0x0034);
codeScancodeMap.set('Slash', 0x0035);
codeScancodeMap.set('ShiftRight', 0x0036);
codeScancodeMap.set('NumpadMultiply', 0x0037);
codeScancodeMap.set('AltLeft', 0x0038);
codeScancodeMap.set('Space', 0x0039);
codeScancodeMap.set('CapsLock', 0x003a);
codeScancodeMap.set('F1', 0x003b);
codeScancodeMap.set('F2', 0x003c);
codeScancodeMap.set('F3', 0x003d);
codeScancodeMap.set('F4', 0x003e);
codeScancodeMap.set('F5', 0x003f);
codeScancodeMap.set('F6', 0x0040);
codeScancodeMap.set('F7', 0x0041);
codeScancodeMap.set('F8', 0x0042);
codeScancodeMap.set('F9', 0x0043);
codeScancodeMap.set('F10', 0x0044);
codeScancodeMap.set('Pause', 0xe045);
codeScancodeMap.set('ScrollLock', 0x0046);
codeScancodeMap.set('Numpad7', 0x0047);
codeScancodeMap.set('Numpad8', 0x0048);
codeScancodeMap.set('Numpad9', 0x0049);
codeScancodeMap.set('NumpadSubtract', 0x004a);
codeScancodeMap.set('Numpad4', 0x004b);
codeScancodeMap.set('Numpad5', 0x004c);
codeScancodeMap.set('Numpad6', 0x004d);
codeScancodeMap.set('Numpadset' as KeyboardEventCode, 0x004e);
codeScancodeMap.set('Numpad1', 0x004f);
codeScancodeMap.set('Numpad2', 0x0050);
codeScancodeMap.set('Numpad3', 0x0051);
codeScancodeMap.set('Numpad0', 0x0052);
codeScancodeMap.set('Numpsetecimal' as KeyboardEventCode, 0x0053);
codeScancodeMap.set('IntlBackslash', 0x0056);
codeScancodeMap.set('F11', 0x0057);
codeScancodeMap.set('F12', 0x0058);
codeScancodeMap.set('IntlYen', 0x007d);
codeScancodeMap.set('MediaTrackPrevious', 0xe010);
codeScancodeMap.set('MediaTrackNext', 0xe019);
codeScancodeMap.set('NumpadEnter', 0xe01c);
codeScancodeMap.set('ControlRight', 0xe01d);
codeScancodeMap.set('AudioVolumeMute', 0xe020);
codeScancodeMap.set('MediaPlayPause', 0xe022);
codeScancodeMap.set('MediaStop', 0xe024);
codeScancodeMap.set('AudioVolumeDown', 0xe02e);
codeScancodeMap.set('VolumeDown', 0xe02e);
codeScancodeMap.set('AudioVolumeUp', 0xe030);
codeScancodeMap.set('VolumeUp', 0xe030);
codeScancodeMap.set('BrowserHome', 0xe032);
codeScancodeMap.set('Numpsetivide' as KeyboardEventCode, 0xe035);
codeScancodeMap.set('PrintScreen', 0xe037);
codeScancodeMap.set('AltRight', 0xe038);
codeScancodeMap.set('NumLock', 0x0045);
codeScancodeMap.set('Home', 0xe047);
codeScancodeMap.set('ArrowUp', 0xe048);
codeScancodeMap.set('PageUp', 0xe049);
codeScancodeMap.set('ArrowLeft', 0xe04b);
codeScancodeMap.set('ArrowRight', 0xe04d);
codeScancodeMap.set('End', 0xe04f);
codeScancodeMap.set('ArrowDown', 0xe050);
codeScancodeMap.set('PageDown', 0xe051);
codeScancodeMap.set('Insert', 0xe052);
codeScancodeMap.set('Delete', 0xe053);
codeScancodeMap.set('OSLeft', 0xe05b);
codeScancodeMap.set('OSRight', 0xe05c);
codeScancodeMap.set('ContextMenu', 0xe05d);
codeScancodeMap.set('BrowserSearch', 0xe065);
codeScancodeMap.set('BrowserFavorites', 0xe066);
codeScancodeMap.set('BrowserRefresh', 0xe067);
codeScancodeMap.set('BrowserStop', 0xe068);
codeScancodeMap.set('BrowserForward', 0xe069);
codeScancodeMap.set('BrowserBack', 0xe06a);
codeScancodeMap.set('NumpadComma', 0x007e);
codeScancodeMap.set('NumpadEqual', 0x0059);
codeScancodeMap.set('F13', 0x0064);
codeScancodeMap.set('F14', 0x0065);
codeScancodeMap.set('F15', 0x0066);
codeScancodeMap.set('F16', 0x0067);
codeScancodeMap.set('F17', 0x0068);
codeScancodeMap.set('F18', 0x0069);
codeScancodeMap.set('F19', 0x006a);
codeScancodeMap.set('F20', 0x006b);
codeScancodeMap.set('F21', 0x006c);
codeScancodeMap.set('F22', 0x006d);
codeScancodeMap.set('F23', 0x006e);
codeScancodeMap.set('F24', 0x0076);
codeScancodeMap.set('KanaMode', 0x0070);
codeScancodeMap.set('Lang2', 0x0071);
codeScancodeMap.set('Lang1', 0x0072);
codeScancodeMap.set('IntlRo', 0x0073);
codeScancodeMap.set('Convert', 0x0079);
codeScancodeMap.set('NonConvert', 0x007b);
codeScancodeMap.set('LaunchApp2', 0xe021);
codeScancodeMap.set('Power', 0xe05e);
codeScancodeMap.set('LaunchApp1', 0xe06b);
codeScancodeMap.set('LaunchMail', 0xe06c);
codeScancodeMap.set('MediaSelect', 0xe06d);
